import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=1a4f8afa&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=1a4f8afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f8afa",
  null
  
)

export default component.exports